import styled from 'styled-components';
import { COLOR_WHITE, COLOR_RED } from '../../../assets/styles/colors';
import { BP_MOBILE_MAX } from '../../../assets/styles/breakpoints';
import { rgba } from 'polished';

export default styled.div`
  background: ${COLOR_WHITE};
  box-shadow: 0 8px 15px 0 rgba(47, 46, 65, 0.04);
  padding: 16px 24px;
  width: 100%;
  max-width: 803px;
  border-radius: 12px;
  margin-bottom: 24px;

  &.completed {
    background: #0dbb53;
  }

  &.error {
    background: ${COLOR_RED};
  }
  &.refused {
    background: ${COLOR_RED};
  }
`;

export const CardTopSC = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .left-side {
    display: flex;
    flex-direction: column;
    white-space: nowrap;
    width: calc(100% - 60px);

    p {
      text-overflow: ellipsis;
      max-width: calc(100% - 30px);
      overflow: hidden;

      &:nth-child(2) {
        white-space: pre-wrap;
        text-overflow: initial;
        max-width: calc(100% - 20px);
      }
    }
  }
  .right-side {
    width: 60px;
    width: fit-content;
    display: flex;
    justify-content: flex-end;
    svg {
      margin-left: 32px;
    }
  }
  &.without-insurance {
    .right-side {
      svg {
        #outline-transparent {
          fill: ${rgba(COLOR_RED, 0.5)};
        }
        #check-circle-2 {
          stroke: ${COLOR_RED};
        }
      }
    }
  }
  &.completed {
    .right-side {
      svg {
        #outline-transparent {
          fill: #ffffff;
        }
        #check-circle-2 {
          stroke: #ffffff;
        }
      }
    }
  }

  @media (max-width: ${BP_MOBILE_MAX}px) {
    .left-side {
      width: calc(100% - 60px);
      &.loading {
        width: calc(100% - 160px);
      }
    }
  }
`;
